import React, { useEffect } from "react";
import Glide from "@glidejs/glide";
import "@glidejs/glide/dist/css/glide.core.min.css";
import "@glidejs/glide/dist/css/glide.theme.min.css";
import "./styles/testminonial.css";

const testimonials = [
  {
   
   
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    text: "Exceptional service! Samah Home Care provided top-notch assistance for my elderly parents. Their caregivers are compassionate, professional, and truly go the extra mile to ensure comfort and well-being. Highly recommended!",
    rating: 5,
  },
  {
    
 
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    text: "Professional and caring staff! Samah Home Care has been a lifesaver for my family. Their team is always on time, well-trained, and genuinely cares about their clients. They have given us peace of mind knowing our loved ones are in great hands.",
    rating: 4,
  },
  {
 
   
    image: "https://randomuser.me/api/portraits/men/51.jpg",
    text: "I appreciate the personalized service and attention to detail at Samah Home Care. The caregivers treat clients like family and always provide warm, respectful, and reliable support. They’ve truly made a positive impact on my loved one’s life.",
    rating: 5,
  },
  {
    
  
    image: "https://randomuser.me/api/portraits/women/58.jpg",
    text: "Reliable and compassionate! The caregivers at Samah Home Care are trained professionals who are patient, kind, and highly experienced. They offer excellent support for seniors, ensuring they feel safe, comfortable, and well cared for at all times.",
    rating: 4,
  },
  {
  
    
    image: "https://randomuser.me/api/portraits/men/61.jpg",
    text: "Fantastic service! The caregivers at Samah Home Care are truly dedicated and professional. Their commitment to high-quality care, dignity, and respect for clients is unmatched. If you’re looking for compassionate home care services, look no further!",
    rating: 5,
  },
];

const Testimonial = () => {
  useEffect(() => {

    const glide = new Glide(".glide", {
      type: "carousel",
      perView: 1,
      autoplay: 3000,
      hoverpause: true,
      animationDuration: 800,
    });

    glide.mount();

    return () => {
      glide.destroy(); // Cleanup to prevent issues
    };
  }, []); // Empty dependency array ensures it runs only once

  return (
    <div className="testimonial-container">
     
      <div className="glide">
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {testimonials.map((item, index) => (
              <li className="glide__slide" key={index}>
                <div className="testimonial-card">
                  <img src={item.image} alt={item.name} className="testimonial-img" />
                  <h3 className="testimonial-name">{item.name}</h3>
                  <p className="testimonial-role">{item.role}</p>
                  <p className="testimonial-text">"{item.text}"</p>
                  <div className="testimonial-rating">
                    {"★".repeat(item.rating)}{"☆".repeat(5 - item.rating)}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="glide__arrows" data-glide-el="controls">
          <button className="glide__arrow glide__arrow--left" data-glide-dir="<">
            ‹
          </button>
          <button className="glide__arrow glide__arrow--right" data-glide-dir=">">
            ›
          </button>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
